import React from 'react';
import { Loader } from "semantic-ui-react";
import { classnames } from '../../../../utils/classnames'
import './button.css';

export default function Button({ as = null, label, fluid = false, disabled, labelIcon, onClick = () => {}, isLoading = false, className, type, ...rest }) {

	const Component = as || 'button';
	const _onClick = React.useCallback(() => {
		if (disabled || isLoading) {
			return null;
		}
		onClick();
	}, [disabled, onClick, isLoading]);

	return (
		<div className={classnames('neo-button-wrapper', {
			'neo-button-fluid': fluid,
		})}>
			<Loader size="mini" active={isLoading} />
			<Component
				className={classnames('neo-button', type, className, {
					'disabled': disabled || isLoading
				})}
				onClick={_onClick}
				aria-disabled={disabled}
				{...rest}
			>
				<div className={classnames('neo-button-label-and-icon', {'disabled': disabled || isLoading})}>
					{label}
				</div>
			</Component>
		</div>
	);
}

export const ButtonGroup = ({ children, style, className }) => (
	<div
		className={classnames('neo-button-group', className)}
		style={style}
	>
		{children}
	</div>
);
